function $runUFUNC() {
  for (const k in this.$computeds) {
    this.$updateUFUNC(k, this.$computeds[k]);
  }
}
function $updateUFUNC(designId, ufunc) {
  if (!this.$ufuncWatchs) {
    this.$ufuncWatchs = {};
  }
  let oldWatch = this.$ufuncWatchs[designId];
  if (oldWatch) {
    //销毁老监听器
    oldWatch();
    delete this.$ufuncWatchs[designId];
  }
  let uw = $UFUNCWatch.call(this, ufunc);
  this.$ufuncWatchs[designId] = uw;
}
function $registerUFUNC(designId, ufunc) {
  this.$computeds[designId] = ufunc;
  if (this.$isDataLoaded) {
    this.$updateUFUNC(designId, ufunc);
  }
}
function $unRegisteUFUNC(designId, ufunc) {
  this.$data.$computeds?.[designId] && delete this.$data.$computeds[designId];
  const uw = this.$ufuncWatchs?.[designId];
  if (uw && dsf.isFunction(uw)) {
    uw();
    delete this.$ufuncWatchs[designId];
  }
}

//计算公式监听
function $UFUNCWatch(ufunc) {
  let _this = this;
  const watchFn = function () {
    if (this.$isDataLoaded) {
      const uf = dsf.isFunction(ufunc) ? ufunc() : ufunc;
      const { computed, self } = uf;
      let local = self.local;
      let {res, type} = computed.call(this, _this, local);
      if (type === 'hasUnDef' && !ufunc.immediate) {
        return undefined;
      }
      let valStr = res + "";
      // 使用正则表达式检查特殊字符串
      let isSpecial = valStr.match(/NaN|Infinity|undefined/);
      if (isSpecial) {
        return null;
      }
      return res;
    }
    return null;
  };
  const watchHandler = function (v) {
    v && ufunc.model.callback.call(this, v);
  };
  let uw = this.$watch(watchFn, watchHandler, {
    // deep: true,
    // immediate: ufunc.immediate
    immediate: true
  });
  return uw;
}

export { $runUFUNC, $updateUFUNC, $registerUFUNC, $unRegisteUFUNC, $UFUNCWatch };
